import { html, on, rune, View } from 'rune-ts';
import klass from './PopupStoreSection.module.scss';
import { PopupStoreItemCardType } from '../../../../../features/PopupStores/type';
import { typoPcMo } from '../../../../../shared/typography/typo';
import { format } from 'date-fns';
import { MShopUtilF } from '../../../../../../../modules/MShop/Util/F/Function/module/MShopUtilF';
import { mpsPostMessage } from '../../../../../shared/app/util';
import { makeEmptyScreenNavigate } from '../../../../../shared/app/navigate';
import { getResizedUrl } from '../../../../../shared/util/image';

interface PopupStoreCardProps {
  popup_store: PopupStoreItemCardType;
}

export class PopupStoreCard extends View<PopupStoreCardProps> {
  override template({ popup_store }: PopupStoreCardProps) {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    return html`
      <div class="${klass.popup_store_card}">
        <img
          class="${klass.image}"
          src="${getResizedUrl({
            url: popup_store.list_thumbnail,
            width: 1920 * 2,
            format: 'jpeg',
            quality: 85,
          })}"
          alt="팝업스토어 썸네일 이미지"
        />
        <div class="${klass.content_wrapper}">
          <div class="${klass.category} ${typoPcMo({ is_mobile, pc: '14_bold', mo: '14_bold' })}">
            ${html.preventEscape(popup_store.creator_name)}
          </div>
          <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '20_bold', mo: '20_bold' })}">
            ${html.preventEscape(popup_store.title)}
          </div>
          <div class="${klass.description} ${typoPcMo({ is_mobile, pc: '14_medium', mo: '14_medium' })}">
            ${html.preventEscape(popup_store.description)}
          </div>
          <div class="${klass.duration} ${typoPcMo({ is_mobile, pc: '14_medium', mo: '14_medium' })}">
            ${format(new Date(popup_store.start_at), 'yyyy-MM-dd')} ~
            ${format(new Date(popup_store.end_at), 'yyyy-MM-dd')}
          </div>
        </div>
      </div>
    `;
  }

  @on('click')
  click() {
    if (MShopUtilF.isApp()) {
      mpsPostMessage(makeEmptyScreenNavigate(`/${ET.lang}/@/popup-store/${this.data.popup_store.id}`));
    } else {
      window.location.href = `/${ET.lang}/@/popup-store/${this.data.popup_store.id}`;
    }
  }
}
